import {StatusReason} from 'api/generated';

export const POSSIBLE_FEES = [
  'Priority support daily fee',
  'External MPI daily fee',
  'Chargeback protection',
  'Webhooks plugin daily fee',
  'Business Intelligence Suite daily fee',
  'Google Reseñas 5*',
  'Yumminn Bizum Fee',
  'Yumminn EU Card Fee',
  'Yumminn NOEU Card Fee',
  'Bizum Fee',
  'Card Fee'
];

export const ACCOUNT_FILTERS = {
  id: 'Account ID',
  name: 'Account name',
  adminEmail: 'Admin email',
  secret: 'Secret',
  apiKey: 'API key',
  businessCountry: 'Country',
  businessLegalName: 'Legal name',
  businessCompanyName: 'Company name',
  businessDocumentNumber: 'Tax Identification Number (CIF)',
  businessEmail: 'Business email',
  businessWebsite: 'Website',
  billingPlan: 'Billing plan',
  referralCode: 'Referral code',
  promoCode: 'Promo code',
  dynamicBilling: 'Has dynamic billing',
  payoutTermsSuspended: 'Payouts suspended',
  masterAccountId: 'Master account',
  churned: 'Is churned',
  blocked: 'Is blocked',
  tags: 'Tag',
  riskProfile: 'Risk profile',
  accountExecutive: 'Account executive',
  representativeName: 'Representative name',
  representativeDocumentNumber: 'Representative document number'
};

export const MASTER_ACCOUNT_FILTERS = {
  id: 'Master Account ID',
  name: 'Master Account name',
  promoCode: 'Promo code',
  adminEmail: 'Admin email'
};

export const AFFILIATE_FILTERS = {
  email: 'Email'
};

export const PAYMENT_FILTERS = {
  shopName: 'Store name',
  shopCountry: 'Store country',
  acquirer: 'Acquirer',
  processor: 'Payment processor',
  customerEmail: 'Customer email',
  customerName: 'Customer name',
  customerPhone: 'Customer phone number',
  id: 'Payment ID',
  authorizationCode: 'Authorization code',
  subscriptionId: 'Subscription ID',
  sequenceId: 'Sequence ID',
  orderId: 'Order ID',
  providerReferenceId: 'Provider reference ID',
  paymentMethodCardLast4: 'Card last 4 digits',
  paymentMethodMethod: 'Payment method',
  paymentMethodCardTokenizationMethod: 'Digital wallet',
  sessionIp: 'Session IP',
  traceDetailsSource: 'Source',
  masterAccountId: 'Master account',
  billingPlan: 'Billing plan',
  storeId: 'Store',
  amount: 'Amount',
  currency: 'Currency'
};

export const PAYOUT_FILTERS = {
  storeId: 'Store'
};

export const PAYMENT_EXTRA_FILTERS = {
  paymentMethodBizumIntegrationType: 'Integration type',
  paymentMethodCardBrand: 'Card brand'
};

export const SUBSCRIPTION_FILTERS = {
  paymentMethod: 'Payment method'
};

export const SUBSCRIPTION_ADMIN_FILTERS = {
  acquirer: 'Acquirer',
  masterAccountId: 'Master account',
  billingPlan: 'Billing plan',
  source: 'Source'
};

export const NOT_CONFIGURED_REASONS = [
  StatusReason.REAL_HOLDERS_DOCS,
  StatusReason.NON_COMMERCIAL_COMPANY_DOCS,
  StatusReason.NON_COMPLIANT_WEBSITE,
  StatusReason.OTHER_COMPANY_WEBSITE,
  StatusReason.HIGH_RISK_GOODS,
  StatusReason.JOINT_OWNERSHIP,
  StatusReason.REPEAT_ONBOARDING,
  StatusReason.BANK_OWNERSHIP_CERT_REQUIRED,
  StatusReason.ID_VERIFICATION_REQUIRED,
  StatusReason.CBD_PRODUCTS,
  StatusReason.OTHER
];

export const REJECTED_REASONS = [
  StatusReason.INCOMPLETE_DOCS,
  StatusReason.RESTRICTED_CATEGORY,
  StatusReason.NOT_COMPLIANT_BUSINESS,
  StatusReason.OTHER
];

export const SUSPENDED_REASONS = [
  StatusReason.CHARGEBACKS,
  StatusReason.CUSTOMER_COMPLAINTS,
  StatusReason.SUSPICIOUS_ACTIVITY,
  StatusReason.UPDATE_BILLING_INFO,
  ...REJECTED_REASONS
];
